// searchReducer.js
import {
    NARRATIVE_SEARCH_REQUEST,
    NARRATIVE_SEARCH_SUCCESS,
    NARRATIVE_SEARCH_FAILURE
} from '../../../Constants/actionTypes';

const initialState = {
    loading: false,
    results: [],
    error: null,
};

const searchReducer = (state = initialState, action) => {
    switch (action.type) {
        case NARRATIVE_SEARCH_REQUEST:
            return {
                ...state,
                loading: true,
                results: [],
                error: null,
            };
        case NARRATIVE_SEARCH_SUCCESS:
            return {
                ...state,
                loading: false,
                results: action.payload,
            };
        case NARRATIVE_SEARCH_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

export default searchReducer;
